import React, { useEffect, useState } from 'react';
import './AgentVSNWorld.css'; // ✅ Agent-themed CSS

const CHANNELS = {
    vsnWorld: {
        id: 'UCwXdRTjP4RO3TFNfEEafDKw',
        label: 'VSN World'
    },
    trainingVideos: {
        id: 'UC82ALhXKYfX4BtDrzm8oM3A',
        label: 'Player Development Program'
    }
};

const AgentVSNWorld = () => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTab, setSelectedTab] = useState('vsnWorld'); // Default: VSN World

    const fetchVideosFromDB = async (channelId) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`http://localhost:5000/api/videos?channelId=${channelId}`);
            const data = await response.json();
            if (Array.isArray(data)) {
                setVideos(data);
            } else {
                setVideos([]);
                console.error('Unexpected format from /api/videos:', data);
            }
        } catch (err) {
            console.error('Failed to fetch stored videos:', err);
            setError('Failed to load videos.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const channelId = CHANNELS[selectedTab].id;
        fetchVideosFromDB(channelId);
    }, [selectedTab]);

    return (
        <div className="training-videos" style={{ fontFamily: 'Arial, sans-serif' }}>
            <h2>Agent VSN World</h2>

            <div className="tab-toggle">
                {Object.entries(CHANNELS).map(([key, { label }]) => (
                    <button
                        key={key}
                        className={selectedTab === key ? 'active' : ''}
                        onClick={() => setSelectedTab(key)}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {loading && <p>Loading...</p>}
            {error && <p className="error">{error}</p>}

            {!loading && !error && (
                <div className="video-list">
                    {videos.map((video, index) => (
                        <div key={index} className="video-card">
                            <div className="video-title">{video.title}</div>
                            <div className="video-description">{video.description}</div>
                            <iframe
                                className="video-player"
                                src={video.embedUrl}
                                title={video.title}
                                allowFullScreen
                            ></iframe>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AgentVSNWorld;








